import ArchiveJobModal from "./ArchiveJobModal";
export default ArchiveJobModal;
